var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlreadyInCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1234",
    "data-name": 1234,
    transform: "translate(-8468 -2049)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nxt",
    transform: "translate(-1240 -845)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7155",
    "data-name": "Path 7155",
    d: "M40,0A40,40,0,1,1,0,40,40,40,0,0,1,40,0Z",
    transform: "translate(9708 2894)",
    fill: "#d2e3ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fast_Delivery",
    transform: "translate(8458.667 1997.2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3425",
    "data-name": "Rectangle 3425",
    width: 32,
    height: 32,
    rx: 4,
    transform: "translate(33.333 75.8)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9211",
    "data-name": "Path 9211",
    d: "M262.524,76V86.524l-5.262-3.508L252,86.524V76",
    transform: "translate(-208.28 0.013)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_594",
    "data-name": "Line 594",
    x2: 4,
    transform: "translate(54.333 100.8)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlreadyInCart);
export default __webpack_public_path__ + "static/media/alreadyInCart.42446425f0e5e6a626e51b4c8de45a0d.svg";
export { ForwardRef as ReactComponent };